import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navbar.module.scss';
import synnexLogoWhite from '../../Assets/Images/Synnex-logo-white.svg';
import synnexLogoDark from '../../Assets/Images/synnex-logo-dark.svg';
import ThemeSwitcher from '../../Components/ThemeSwitcher';
import ProfileIcon from '../../Components/Profile';
// import useLogout from '../../hooks/useLogout';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const logout = useLogout();

  const getNavLinkClass = ({ isActive }) => {
    return isActive ? `${styles.navLink} ${styles.active}` : styles.navLink;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <div className={styles.logo}>
          <img src={synnexLogoWhite} alt="Synnex Logo" className={styles.logoWhite} />
          <img src={synnexLogoDark} alt="Synnex Logo" className={styles.logoDark} />
        </div>
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            <li><NavLink to="/guides" className={getNavLinkClass} onClick={toggleMenu}><i className="material-icons">book</i><span className='text-md'>Guides</span></NavLink></li>
            <li><NavLink to="/workflows" className={getNavLinkClass} onClick={toggleMenu}><i className="material-icons">hub</i><span className='text-md'>Workflows</span></NavLink></li>
            <li><NavLink to="/api-reference" className={getNavLinkClass} onClick={toggleMenu}><i className="material-icons">code</i><span className='text-md'>API Reference</span></NavLink></li>
            <li><NavLink to="/change-logs" className={getNavLinkClass} onClick={toggleMenu}><i className="material-icons">history</i><span className='text-md'>Changelog</span></NavLink></li>
          </ul>
        </nav>
      </div>
      <div className={styles.headerRight}>
        {/* <div className={styles.search}>
          <input type="text" placeholder="Search" />
          <span>CTRL-K</span>
        </div> */}
        <ThemeSwitcher />
        <ProfileIcon />
        {/* <button className={styles.loginButton} onClick={handleLogout}>Logout</button> */}
        <button className={styles.hamburger} onClick={toggleMenu}>
          <i className="material-icons">{isMenuOpen ? 'close' : 'menu'}</i>
        </button>
      </div>
    </header>
  );
};

export default Navbar;